import { IFeature } from 'mod/featureV2/interface';

export const swiperPicTxt: IFeature = {
    moduleId: 'swiperPicTxt',
    type: 'swiperPicTxt',
    title: 'swiperPicTxt',
    config: {
        imageWidth: 960,
        imageHeight: 608,
        navigation: true,
        pagination: true,
    },
    list: [
        {
            picUrl: 'asset/width-1920/picture/98dd860b855df2c3c89fa371c1c87fdb.jpg',
            linkUrl: 'https://www.vivosun.com/products/revolution-smart-grow-box',
            target: '_blank',
            title: 'Revolution Smart Grow Box',
            description: 'Seamlessly integrate sunlight, air, water, and nutrients. Sustainable and ideal for diverse plants, from seed to harvest.',
        },
        {
            picUrl: 'asset/width-1920/picture/c6eb1359d94017f96a6cb4a697d77176.jpg',
            linkUrl: 'https://www.vivosun.com/products/revolution-smart-grow-box',
            title: 'Ready-to-Grow Kit',
            description: 'Seamlessly integrate sunlight',
        },
        {
            picUrl: 'asset/width-1920/picture/a447362a2ac3c7ff97b0fde4745e825c.jpg',
            title: 'Intelligent Remote Control',
            description: 'Seamlessly integrate sunlight, air, water, and nutrients. Sustainable and ideal for diverse plants, from seed to harvest.',
        },
    ]
};